export const texts  = {
    AVISO : 'Aún no tiene cuenta de usuario',
    EXPLICACION:'Es necesario darse de alta como interesado para presentar una solicitud con certificado digital. Si acepta:',
    PASO1: '1.',
    PASO2: '2.',
    PASO1EXP: 'Accederá a la página para darse de alta como interesado',
    PASO2EXP: 'Una vez dado de alta como interesado continuará a la bandeja de solicitudes',
}